import { render, staticRenderFns } from "./UserPointMngtList.vue?vue&type=template&id=332e63f2"
import script from "./UserPointMngtList.vue?vue&type=script&lang=js"
export * from "./UserPointMngtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports